/**
 * <TutorHomeTodo> — « À faire · n », ce que l'accueil demande au masteur.
 *
 * UNE liste à la place des bannières de l'ancien accueil, qui se remplaçaient l'une l'autre (le
 * carrousel de `TutorTaskBanner.js`, « 1 / 4 », puis la carte « Formation » dessous) : chaque tâche
 * est une ligne de la même carte (`<TodoRow>`, la ligne « à faire » de tous les espaces), dans
 * l'ordre de priorité de l'ancienne bannière — préparer le live, les comptes-rendus manquants,
 * confirmer ses créneaux, compléter son profil, enregistrer son compte Stripe — puis la formation.
 * L'ordre arrive du view-model ; cette liste le rend.
 *
 * **Une tâche, une ligne** (allègement du 05/11) : le glyphe, un titre court, l'action. Pas de phrase
 * dessous ni de surtitre : l'adaptateur n'en écrit plus, et l'urgence des comptes-rendus est un ton
 * de la ligne (`tutorTodoAdapter`).
 *
 * Rien à faire : la section n'est pas montée (comme « À faire » chez le parent) — un état vide ici
 * serait un rappel permanent que tout va bien.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Skeleton } from "../../atoms/Skeleton"
import { CardList, CardListRow } from "../../molecules/CardList"
import { List } from "../../molecules/List"
import { TodoRow } from "../../molecules/TodoRow"
import { type UITutorTodo } from "../../../ports/primary/ui/types/tutorCoquilleAccueil"

export type TutorHomeTodoProps = {
    todos: UITutorTodo[]
    onTodoPress?: (todo: UITutorTodo) => void
    testID?: string
}

export function TutorHomeTodo(props: TutorHomeTodoProps) {
    const { todos, onTodoPress, testID } = props
    if (todos.length === 0) return null

    return (
        <List title={`À faire · ${todos.length}`} testID={testID}>
            <CardList>
                {todos.map((todo) => (
                    <TodoRow key={todo.id} todo={todo} onPress={onTodoPress} />
                ))}
            </CardList>
        </List>
    )
}

/** Sa forme dans le squelette : deux tâches d'une ligne, le glyphe, le titre, l'action. */
export function TutorHomeTodoSkeleton() {
    return (
        <List title="À faire">
            <CardList>
                {[0, 1].map((row) => (
                    <CardListRow key={row}>
                        <Row gap="3" align="center">
                            <Skeleton shape="circle" size={20} />
                            <View style={styles.body}>
                                <Skeleton textSize="text-md" width={180} />
                            </View>
                            <Skeleton textSize="text-md" width={72} />
                        </Row>
                    </CardListRow>
                ))}
            </CardList>
        </List>
    )
}

const styles = StyleSheet.create(() => ({
    body: { flex: 1, flexShrink: 1 },
}))
